import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';
import Image from '../WhyHostFormBlock1/Image';

import submit from './submit';
import validate from './validate';
import messages from '../../../../locale/messages';

import s from './WhyHostFormBlock5.css';
import cs from '../../../../components/commonStyle.css';

class WhyHostFormBlock5 extends Component {
  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, workImage4, workImage4loader, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['workTitleHeading', 'peaceTitle1', 'peaceTitle2', 'peaceTitle3', 'peaceContent1', 'peaceContent2', 'peaceContent3', 'peaceTitleHeading'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={s.headerTitle}><FormattedMessage {...messages.WhyBecomeOwnerBlock5} /></h1>
            <form onSubmit={handleSubmit((values) => {
              const payload = { ...values, ...formValues };
              console.log('🚀 [WhyHostFormBlock5] Sending:', payload);
              return submit(payload, dispatch);
            })}>
              {hiddenFields}
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.workTitleHeading} /></label>
                <MultiLanguageInput
                  baseField="workTitleHeading"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew}><FormattedMessage {...messages.imageLabel} /></label>
                  <Image image={workImage4} fieldName={"workImage4"} loader={workImage4loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.peaceTitleLabel1} /></label>
                <MultiLanguageInput
                  baseField="peaceTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.peaceContentLabel1} /></label>
                <MultiLanguageInput
                  baseField="peaceContent1"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.peaceTitleLabel2} /></label>
                <MultiLanguageInput
                  baseField="peaceTitle2"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.peaceContentLabel2} /></label>
                <MultiLanguageInput
                  baseField="peaceContent2"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>

              <FormGroup className={s.noMargin}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                    <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                      <FormattedMessage {...messages.save} />
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

WhyHostFormBlock5 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock5);

const selector = formValueSelector('WhyHostForm');

const textFields = ['workTitleHeading', 'peaceTitle1', 'peaceContent1', 'peaceTitle2', 'peaceContent2'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  
  return {
    formValues,
    workImage4loader: state?.loader?.workImage4,
    workImage4: selector(state, 'workImage4'),
  };
};

const mapDispatch = {};

export default compose(
  withStyles(s, cs),
  injectIntl,
  connect(mapState, mapDispatch)
)(WhyHostFormBlock5);